<div class="table-title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor"> {{ sectionTitle }} </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<div>
    <div>
        <div
            *ngIf="textAdditionAboveEmsTable != null"
            [innerHtml]="textAdditionAboveEmsTable | safeHtml"
            [style.--selected-background-color]="styleOptions.backgroundColor"
            [style.color]="styleOptions.textColor"
        ></div>

        <ng-container *ngFor="let table of tables">
            <aumico-annualReport-equity-movement-swiss-display-component
                [styleOptions]="styleOptions"
                [rows]="table.rows"
                [columnNames]="columnNamesOf(table)"
            >
            </aumico-annualReport-equity-movement-swiss-display-component>
        </ng-container>

        <div
            *ngIf="textAdditionBelowEmsTable != null"
            [innerHtml]="textAdditionBelowEmsTable | safeHtml"
            [style.--selected-background-color]="styleOptions.backgroundColor"
            [style.color]="styleOptions.textColor"
        ></div>
    </div>
</div>
